export const styles = {
  root: {
    width: '90%',
    margin: 'auto',
    maxWidth: 1200,
    flexGrow: 1,
  },
  th: {
    backgroundColor: '#ddd',
  },
  row: {
    '&:last-child td, &:last-child th': {
      border: 0
    }
  },
  input: {
    borderRadius: 4,
    fontSize: '1rem',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    padding: '6px 0 7px'
  },
  btnArea: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '1rem 5%'
  },
}